// MONARCH CONSTANTS
export const MONARCH_RULESETS = {
  LANDING_PAGE: '0840092c-673b-4d0f-9b22-74cb563000e8'
};

export const DEFAULT_FUSE_NUMBER = '8664994271';
